import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import { LocalizationProvider as LocalizationProvider$1 } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/lv';
import 'dayjs/locale/nl';
import 'dayjs/locale/pt';
import 'dayjs/locale/sv';
import 'dayjs/locale/ko';
import 'dayjs/locale/zh';
import 'dayjs/locale/ja';
import 'dayjs/locale/nb';
import { useConfigContextLoose } from '../config-provider/config-provider.js';

var LocalizationProvider = function LocalizationProvider(_ref) {
  var children = _ref.children,
    localizationProviderProps = _ref.localizationProviderProps;
  var _a, _b;
  var _useConfigContextLoos = useConfigContextLoose(),
    configProviderLocalizationProviderProps = _useConfigContextLoos.localizationProviderProps;
  return jsx(LocalizationProvider$1, Object.assign({
    localeText: {
      calendarWeekNumberHeaderText: ''
    }
  }, configProviderLocalizationProviderProps, localizationProviderProps, {
    dateAdapter: (_b = (_a = localizationProviderProps === null || localizationProviderProps === undefined ? undefined : localizationProviderProps.dateAdapter) !== null && _a !== undefined ? _a : configProviderLocalizationProviderProps === null || configProviderLocalizationProviderProps === undefined ? undefined : configProviderLocalizationProviderProps.dateAdapter) !== null && _b !== undefined ? _b : AdapterDayjs,
    children: children
  }));
};

export { LocalizationProvider };
